<template>
  <v-layout wrap class="container px-2 py-0">
    <router-view/>
  </v-layout>
</template>

<script>

export default {
  name: 'AppealPage',
  destroyed() {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
</style>
